import styled from '@emotion/styled'
import { motion } from 'framer-motion'
import { useRecoilState, useRecoilValue } from 'recoil'

import { paramsState, roomWindowScaleState } from '@/store/room'

import Head from '../Head'
import Tools from '../Tools'
import SmallScreenToolBar from './components/SmallScreenToolBar'
import Student, { Temp } from './components/Student'
import Teacher, { TeacherTemp } from './components/Teacher'

export const position: string[] = [
  '',
  'absolute ease-in-out duration-300 top-0 left-[92.875vh] w-[72vh] h-[96vh]',
  'absolute ease-in-out duration-300 top-[9.12vh] left-0 w-[16.875vh] h-[22.5vh]',
  'absolute ease-in-out duration-300 top-[33.62vh] left-0 w-[16.875vh] h-[22.5vh]',
  'absolute ease-in-out duration-300 top-[58.12vh] left-0 w-[16.875vh] h-[22.5vh]',
  'absolute ease-in-out duration-300 top-[82.62vh] left-0 w-[16.875vh] h-[22.5vh]'
]

export const screenPosition: string[] = [
  '',
  'absolute ease-in-out duration-300 bottom-5 right-[22px] z-[11] w-[60vh] h-[45vh] rounded-[10px] overflow-hidden',
  'absolute cursor-nesw-resize ease-in-out duration-300 bottom-[20px] left-0 w-full h-full bg-center',
  'absolute cursor-nesw-resize ease-in-out duration-300 top-[69vh] left-0 w-[28vh] h-[21vh]',
  'absolute cursor-nesw-resize ease-in-out duration-300 right-0 bottom-0 w-[28vh] h-[21vh]',
  'absolute cursor-nesw-resize ease-in-out duration-300 top-[23vh] left-0 w-[28vh] h-[21vh]'
]
export default function Index() {
  const params = useRecoilValue(paramsState)
  const [roomWindowScale, setRoomWindowScale] = useRecoilState(roomWindowScaleState)

  const hiddenInView = roomWindowScale !== 'full'
  return (
    <>
      <Container className={`${hiddenInView ? 'w-full h-full' : 'w-[16.875vh] h-[96vh]'} relative`}>
        <div hidden={hiddenInView}>
          <Head />
        </div>
        {params.teacherId ? <Teacher /> : <TeacherTemp />}
        <div hidden={hiddenInView}>
          {params.studentId ? <Student /> : <Temp />}
          <Tools />
        </div>
      </Container>
      <SmallScreenToolBar />
    </>
  )
}

const Container = styled(motion.div)``
